import React, { useEffect, useState } from "react";
import "./RegulatoryComplianceReport.scss";
import { useSelector, useDispatch } from "react-redux";
import LoanTable from "../../../components/LoanTable/LoanTable";
import { Box } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import LoanReportsTable from "../../../components/LoanReportsTable/LoanReportsTable";

const RegulatoryComplianceReport = ({startDate, endDate, duration, isCustomFilter}) => {
  const [reportData, setReportData] = useState([]);

  useEffect(()=> {
    getReportData();
  },[duration, isCustomFilter]);

  const getReportData = async() => {
    try {
      const response = await commonRunQuery(262, `${startDate}/${endDate}`);
      if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
        const reportsArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
        setReportData(reportsArray);
        console.log("getReportData==========",reportsArray);
      } else {
        setReportData([]);
      }
      console.log("RegulatoryComplianceReport_getReportData---------------",response);
    } catch (error) {
      console.log("getReportData_error==========",error);
    }
  }

  const columns = [
    {
      label: 'Loan ID',
      getValue: (row) => row.li?.LoanID ?? ''
    },
    {
      label: 'Borrower Name',
      getValue: (row) => row.record?.BorrowerName?.toString().trim() ? row.record?.BorrowerName : "-"
    },
    {
      label: 'Loan Amount',
      getValue: (row) => row.li?.LoanAmount ?? '',
      align: 'right',
      amount: true
    }
  ];

  return (
    <Box>
        <LoanReportsTable 
          data={reportData} 
          columns={columns} 
          title="Regulatory Compliance Report" 
          formatRow={(row) => [
            row.li?.LoanID,
            row.record?.BorrowerName,
            row.li?.LoanAmount
          ]} 
        />
    </Box>
  )
}

export default RegulatoryComplianceReport;
